// Assets
import continentWorld from "../../assets/img/World--filled.svg";
import continentEurope from "../../assets/img/Europe--filled.svg";
import continentAmerica from "../../assets/img/America--filled.svg";
import continentAfrica from "../../assets/img/Africa--filled.svg";
import continentAsia from "../../assets/img/Asia--filled.svg";
import continentAustralia from "../../assets/img/Australia--filled.svg";

const todaysDate = new Date().toISOString().split("T")[0];
const todaysDateInSevenDays = new Date(
  new Date().setDate(new Date().getDate() + 7)
)
  .toISOString()
  .split("T")[0];

export const IOModel: {
  departureDate: string;
  arrivalDate: string;
  continents: string[];
  travelType: string;
  sportActivities: string;
  people: any;
} = {
  departureDate: todaysDate,
  arrivalDate: todaysDateInSevenDays,
  continents: ["europe"],
  travelType: "tourism-vacation",
  sportActivities: "recreational-sports",
  people: [
    {
      age: 18,
    },
  ],
};

export const worldContinents = [
  { label: "World", value: "world", image: continentWorld },
  { label: "Europe", value: "europe", image: continentEurope },
  { label: "America", value: "america", image: continentAmerica },
  { label: "Africa", value: "africa", image: continentAfrica },
  { label: "Asia", value: "asia", image: continentAsia },
  { label: "Australia", value: "australia", image: continentAustralia },
];

export const travelTypes = [
  {
    label: "Tourism/Vacation",
    name: "travelType",
    value: "tourism-vacation",
  },
  {
    label: "Administrative work",
    name: "travelType",
    value: "work-administrative",
  },
  { label: "Manual work", name: "travelType", value: "work-manual" },
  { label: "Study visit", name: "travelType", value: "study-visit" },
];

export const sportActivities = [
  {
    label: "Recreational sports",
    name: "sportActivities",
    value: "recreational-sports",
  },
  { label: "Risk sports", name: "sportActivities", value: "risk-sports" },
  { label: "Winter sports", name: "sportActivities", value: "winter-sports" },
];
